import profilesActionTypes from './action-types';

export const fetchProfileDetails = payload => ({
  type: profilesActionTypes.FETCH_PROFILE_DETAILS,
  payload,
});

export const fetchProfileDetailsSuccess = payload => ({
  type: profilesActionTypes.FETCH_PROFILE_DETAILS_SUCCESS,
  payload,
});

export const fetchProfileDetailsFail = payload => ({
  type: profilesActionTypes.FETCH_PROFILE_DETAILS_FAIL,
  payload,
});

export const fetchUpdateProfileInfo = payload => ({
  type: profilesActionTypes.FETCH_UPDATE_PROFILE_INFO,
  payload,
});

export const fetchUpdateProfileInfoSuccess = payload => ({
  type: profilesActionTypes.FETCH_UPDATE_PROFILE_INFO_SUCCESS,
  payload,
});

export const fetchUpdateProfileInfoFail = payload => ({
  type: profilesActionTypes.FETCH_UPDATE_PROFILE_INFO_FAIL,
  payload,
});
